import { combineReducers } from "@reduxjs/toolkit";
import patient from "./patient";

const rootReducer = combineReducers({
  patient: patient,
});

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
